import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import {  FETCHING_DATA_SOURCE_CHILDREN_FAILED, FETCHING_DATA_SOURCE_CHILDREN_REQUEST, FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED, FETCHING_DATA_SOURCES_FAILED, FETCHING_DATA_SOURCES_REQUEST, FETCHING_DATA_SOURCES_SUCCEEDED } from "../constants/appConstants";
import buildUrl from "build-url-ts";
import { FetchDataSourceChildrenError, FetchDataSourceChildrenRequest, FetchDataSourceChildrenResponse, FetchDataSourceError, FetchDataSourceRequest, FetchDataSourceResponse } from "../constants/dataSource";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const DATA_SOURCE_BASE_URL = `${apiUrl}/api/1.0`;
const SOURCE_URL = `${DATA_SOURCE_BASE_URL}/datasources`;

export const fetchDataSource = createAction<FetchDataSourceRequest>(FETCHING_DATA_SOURCES_REQUEST);

const fetchingDataSourceSucceeded = createAction<FetchDataSourceResponse>(FETCHING_DATA_SOURCES_SUCCEEDED);

const fetchingDataSourceFailed = createAction<FetchDataSourceError>(FETCHING_DATA_SOURCES_FAILED);

const fetchDataSourceSaga = function* (action: ReturnType<typeof fetchDataSource>): any {
  const accountId = action.payload.accountId;

  const url = new URL(`${SOURCE_URL}/summary/${accountId}`);

  const fetchDataSourceAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDataSourceAPI);
    yield put(fetchingDataSourceSucceeded({datasources: response}));
  } catch (error) {
    yield put(fetchingDataSourceFailed({error}));
  }
};

export const fetchDataSourceChildren = createAction<FetchDataSourceChildrenRequest>(FETCHING_DATA_SOURCE_CHILDREN_REQUEST);

const fetchingDataSourceChildrenSucceeded = createAction<FetchDataSourceChildrenResponse>(FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED);

const fetchingDataSourceChildrenFailed = createAction<FetchDataSourceChildrenError>(FETCHING_DATA_SOURCE_CHILDREN_FAILED);

const fetchDataSourceChildrenSaga = function* (action: ReturnType<typeof fetchDataSourceChildren>): any {
  
  const account = action.payload.account;
  const parent = action.payload.parent;
  const showFile = action.payload.showFile;


  var url = buildUrl(`${SOURCE_URL}`, {
    path: `${account}/inspectChildren`,
  });

  const updateAssetAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        parent: parent,
        showFile: true,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    yield put(fetchingDataSourceChildrenSucceeded({children: response, account, parent}));
  } catch (error) {
    yield put(fetchingDataSourceChildrenFailed({error, account}));
  }
};

export default function* dataSourceSaga() {
  yield takeEvery(FETCHING_DATA_SOURCES_REQUEST, fetchDataSourceSaga);
  yield takeEvery(FETCHING_DATA_SOURCE_CHILDREN_REQUEST, fetchDataSourceChildrenSaga);
}